import { apiGet, rangeParams } from '@/components/dash/overview/modules/widgets/widgetFetch'
import { hasBetaFeature } from '@/utils/betaFeatures'

// Métriques des liens courts mws.li (GET /reporting/short-links) : reporting de page, overview et widget.
// L'engine répond { enabled, has_data, clicks, bot_clicks, previous_clicks, by_day, by_page, by_news_id, top_links, ... }.

// Pas d'appel quand la feature beta est fermée (prod hors programme beta)
export function shortLinksAvailable(user) {
  return hasBetaFeature('url_shortener', user)
}

/**
 * @param {Object} range - { since, until } en timestamps unix (mêmes bornes que les routes overview)
 * @param {Array<string>} pageIds - pages Mashup ; vide = toutes les pages accessibles
 */
export function fetchShortLinkMetrics(range, pageIds = [], { refresh = false, persist = false } = {}) {
  return apiGet(`/reporting/short-links?${rangeParams(range, { pages: pageIds })}`, { refresh, persist })
}

// Raccourcisseur actif pour le compte ET au moins un lien ou un clic sur la période
export function shortLinksVisible(data) {
  return !!(data && data.enabled && data.has_data)
}

// Bornes unix d'une période jour à jour (dates YYYY-MM-DD incluses), comme le reporting de page
export function dayRange(moment, dateStart, dateEnd) {
  return { since: moment(dateStart).unix(), until: moment(dateEnd).endOf('day').unix() }
}

// Clics d'un post du reporting (jointure par news_id via /reporting/solution-post)
export function postShortLinkStats(data, solutionPostMap, post) {
  if (!shortLinksVisible(data) || !post) return null
  const entry = solutionPostMap && solutionPostMap[String(post.post_id || post.id || '')]
  const newsId = entry && entry.news_id
  return (newsId && data.by_news_id && data.by_news_id[newsId]) || null
}
